import { NgModule } from '@angular/core';
import { FunctieCardComponent } from './functie-card.component';
import { MaterialModule } from '../../../app.material.module';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ContentModule } from '../../../services/content/content.module';
import { DonutBarModule } from '../../donut-bar/donut-bar.module';
import { ButtonModule } from '../../button/button.module';

@NgModule({
  declarations: [FunctieCardComponent],
  imports: [CommonModule, RouterModule, ContentModule, MaterialModule, DonutBarModule, ButtonModule],
  exports: [FunctieCardComponent]
})
export class FunctieCardModule {}
